import { useState } from 'react'
import { SelectBoxData } from '../types'

interface UseSelectExtraOptionsBottomsheetProps {
  initialData?: SelectBoxData[]
  initialValue?: SelectBoxData['value']
}
export const useSelectExtraOptionsBottomsheet = (props?: UseSelectExtraOptionsBottomsheetProps) => {
  const { initialData, initialValue } = props || {}
  const [data, setData] = useState<SelectBoxData[]>(initialData || [])
  const [value, setValue] = useState<SelectBoxData['value']>(initialValue || '')
  const [openSelectOptionsBottomSheet, setOpenSelectOptionsBottomSheet] = useState(false)
  const onCloseRequest = () => {
    setOpenSelectOptionsBottomSheet(false)
  }

  const _onSelect = (data: SelectBoxData) => {
    setValue(data.value)
    onCloseRequest()
  }

  return {
    openSelectOptionsBottomSheet,
    setOpenSelectOptionsBottomSheet,
    onCloseRequest,
    data,
    setData,
    value,
    onSelect: _onSelect,
  }
}
